<template>
  <auth-box>
    <div>
      <div ref="registerFormContainer"></div>
      <div class="mx-4">
        <div class="small-text mt-3 mb-4">
          {{ $t("auth.termsAgreePrefix") }}
          <a href="https://essaygrader.ai/terms-of-service" target="_blank">
            {{ $t("auth.termsOfService") }}
          </a>
          {{ $t("auth.and") }}
          <a href="https://essaygrader.ai/privacy-policy" target="_blank">
            {{ $t("auth.privacyPolicy") }}</a
          >.
        </div>

        <div class="divider"></div>

        <p class="mt-4 text-center">
          {{ $t("auth.alreadyHaveAccount") }}
          <a href="/login" data-testid="login-link">{{ $t("auth.login") }}</a>
        </p>
      </div>
    </div>
  </auth-box>
</template>

<script>
import AuthBox from "./auth_box.vue";
import {
  hideCanvasAuthMethods,
  updateFormTitle,
  updateGoogleButtonLabel,
  waitForSignInMount,
} from "./utils";
import { AuthMethod } from "@/components/auth/auth_methods";
import { mapGetters } from "vuex";

export default {
  name: "RegisterForm",

  components: {
    AuthBox,
  },

  computed: {
    ...mapGetters("config", ["features"]),
  },

  async mounted() {
    const clerk = this.$getClerk();
    await clerk.load();
    const container = this.$refs.registerFormContainer;

    clerk.mountSignUp(container, {
      oauthFlow: "popup",
    });
    await waitForSignInMount(container);

    // Unlike the Login form, we continue to display only the Google button and Email form.
    hideCanvasAuthMethods(container);
    updateFormTitle(container, this.$t("auth.signUpToStartGrading"));

    if (this.features.login.includes(AuthMethod.Google)) {
      updateGoogleButtonLabel(container, this.$t("auth.signUpWithGoogle"));
    }
  },
};
</script>

<style scoped lang="scss">
.divider {
  border-bottom: 1px solid #c8c8c8;
  position: relative;
  margin: 12px 0;

  .or {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    background: #fff;
    padding: 0 10px;
  }
}

.small-text {
  font-family: "Roboto", "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}
</style>
